import { CONFIG_CONSTANTS, ERROR_CONSTANTS } from '../actionTypes'

const initState = {
	message: '',
	status: '',
	description: '',
}

const errorReducer = (state = initState, action) => {
	switch (action.type) {
		case 'RESET':
			return initState
		case CONFIG_CONSTANTS.SET_APP_SETTINGS_TO_DEFAULT:
			return initState
		case ERROR_CONSTANTS.ERROR:
			return {
				...state,
				message: action?.error?.message,
				status: action?.error?.status,
				description: action?.error?.description,
			}
		default:
			return state
	}
}
export default errorReducer
